import { CounterBadge as FluentCounterBadge } from "@fluentui/web-components";
/**
 * CounterBadge
 * @summary A CounterBadge component representing a numeric or dot indicator for UI elements, often used to show the number of items in a list or as a notification count.
 *
 * @example
 * ```html
 * <fabric-counter-badge appearance="filled" color="brand" shape="circular" size="medium" count="5" overflow-count="99" show-zero="false" dot="false"></fabric-counter-badge>
 * ```
 *
 * @attr {CounterBadgeAppearance | undefined} appearance - The appearance the badge should have.
 * @attr {CounterBadgeColor | undefined} color - The color the badge should have.
 * @attr {CounterBadgeShape | undefined} shape - The shape the badge should have.
 * @attr {CounterBadgeSize | undefined} size - The size the badge should have.
 * @attr {number} count - The count the badge should have.
 * @attr {number} overflow-count - Max number to be displayed.
 * @attr {boolean} show-zero - If the badge should be shown when count is 0.
 * @attr {boolean} dot - If a dot should be displayed without the count.
 *
 * @prop {number} count - The numeric value for the badge. If not set, defaults to 0.
 * @prop {number} overflowCount - The maximum number to display before showing '+'. Defaults to 99.
 * @prop {boolean} showZero - Determines whether the badge is shown when the count is 0. Defaults to false.
 * @prop {boolean} dot - Displays a dot instead of the count when set to true. Defaults to false.
 *
 * @extends FluentCounterBadge
 * @tagname fabric-counter-badge
 * @public
 */
export class CounterBadge extends FluentCounterBadge {
}
//# sourceMappingURL=counter-badge.js.map